import React, { FC } from 'react'
import { FlexContainer, Text2XL, TextBase, elM5, elFlex1, elHFull, elMt12 } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { cx } from '@linaria/core'
import { PageWrapper, BrandLogo } from '@reapitform/common-ui'
import StepNavigation from '../view/step-navigation'
import { useFormDocument } from '../view/layout/tenant-app-layout'

export const Error: FC = () => {
  const formDocumentData = useFormDocument()

  return (
    <ErrorBoundary>
      <StepNavigation hideNav>
        <PageWrapper hasFullPage>
          <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
            <BrandLogo src={formDocumentData?.agentLogoUrl || '/pwa-152x152.png'} />
            <Text2XL hasBoldText hasMargin tag="h2" hasCenteredText>
              Uh oh!
            </Text2XL>
            <TextBase className={cx(elM5)} hasRegularText hasCenteredText>
              It looks like something went wrong. Please try again or contact your agent if the issue persists.
            </TextBase>
            {formDocumentData?.agencyName && (
              <TextBase hasCenteredText hasBoldText className={elMt12}>
                {formDocumentData.agencyName}
              </TextBase>
            )}
            {formDocumentData?.agencyDisplayContactNumber && (
              <TextBase hasCenteredText tag="span" intent="primary">
                {formDocumentData.agencyDisplayContactNumber}
              </TextBase>
            )}
          </FlexContainer>
        </PageWrapper>
      </StepNavigation>
    </ErrorBoundary>
  )
}
